import {getJsContext, getRecaptchaToken, getUrlTranslation, SuccessSwal} from "../app";
import {ajaxErrorAlert, ajaxPost} from "./utils";

$(function () {
  $(document).on('submit', '#sendPaymentReceiptToEmail', (e) => {
    e.preventDefault();
    const form = $(e.target);

    getRecaptchaToken(form, {position: "center", extraClasses: "w110 p-1"})
      .then(() => {
        const data = form.serializeArray()
        const paymentId = form.find('input[name=payment_id]').val();

        form.loading({
          loadingText: getJsContext('please_wait') + '...',
          position: "center",
          extraClasses: "w110 p-1"
        });

        ajaxPost(getUrlTranslation(`/payment-receipt/${paymentId}/send/`), data, form)
          .then((response) => {
            form.parent().removeClass('show');
            SuccessSwal.fire({
              text: String(response['message']),
            }).then(() => {
              form.find('input[name=email]').val('')
            });
          })
          .catch((errors) => {
            ajaxErrorAlert(errors, form);
          });
      });
  });
});